import React from "react";
import ModalTemplate from "../templates/ModalTemplate";
import CloseIcon from "@mui/icons-material/Close";
import { IconButton } from "@mui/material";
import Button from "../atoms/Button";

type AlertModalProps = {
  open: boolean;
  onClose: () => void;
  children: React.ReactNode;
};

function AlertModal({ children, open, onClose }: AlertModalProps) {
  return (
    <ModalTemplate open={open} handleClose={onClose}>
      <div className="p-2 flex flex-row justify-between items-center bg-[#FAFAFA] min-w-96">
        <span className="font-semibold text-2xl ">Payment terms</span>
        <IconButton onClick={onClose} className="h-8 w-8">
          <CloseIcon />
        </IconButton>
      </div>
      <div className="flex justify-center p-24">{children}</div>
      <div className="bg-[#FAFAFA] flex gap-1 rounded">
        <div className="flex flex-row justify-end items-center w-full gap-2 px-4 py-4">
          <Button
            onClick={onClose}
            className="py-[6px] px-6 rounded  font-semibold text-[18px]"
          >
            {globalThis.translate.em.proposal.contact_modal.cancel}
          </Button>
        </div>
      </div>
    </ModalTemplate>
  );
}

export default AlertModal;
